/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRepresentantApprenantsliesDto } from './FcbRepresentantApprenantsliesDto';
import {
    FcbRepresentantApprenantsliesDtoFromJSON,
    FcbRepresentantApprenantsliesDtoFromJSONTyped,
    FcbRepresentantApprenantsliesDtoToJSON,
} from './FcbRepresentantApprenantsliesDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRepresentantApprenantsliesDtoPaginatedResults
 */
export interface FcbRepresentantApprenantsliesDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRepresentantApprenantsliesDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRepresentantApprenantsliesDto>}
     * @memberof FcbRepresentantApprenantsliesDtoPaginatedResults
     */
    results?: Array<FcbRepresentantApprenantsliesDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRepresentantApprenantsliesDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRepresentantApprenantsliesDtoPaginatedResults interface.
 */
export function instanceOfFcbRepresentantApprenantsliesDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRepresentantApprenantsliesDtoPaginatedResultsFromJSON(json: any): FcbRepresentantApprenantsliesDtoPaginatedResults {
    return FcbRepresentantApprenantsliesDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRepresentantApprenantsliesDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRepresentantApprenantsliesDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRepresentantApprenantsliesDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRepresentantApprenantsliesDtoPaginatedResultsToJSON(value?: FcbRepresentantApprenantsliesDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRepresentantApprenantsliesDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

